import { render, staticRenderFns } from "./zl.vue?vue&type=template&id=1861937c"
import script from "./zl.vue?vue&type=script&lang=js"
export * from "./zl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Workplace\\vueProject\\edu_aim\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1861937c')) {
      api.createRecord('1861937c', component.options)
    } else {
      api.reload('1861937c', component.options)
    }
    module.hot.accept("./zl.vue?vue&type=template&id=1861937c", function () {
      api.rerender('1861937c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/we/zl.vue"
export default component.exports